<template>
    <a-select v-model="selectId" :defaultValue="defaultValue"  @change="changeStation">
        <a-select-option v-for="item in select" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
    </a-select>
</template>

<script>
    export default {
        name: "stationSelectList",
        props:{
          all:{
              type: Boolean,
              default: true
          }
        },
        data(){
            return {
                groupId: 0,
                select: [],
                defaultValue: 0,
                selectId: 0
            }
        },
        mounted(){
          this.loadStation();
        },
        methods:{
            async loadStation(id = this.$Utils.getUserStorage().groupId){
                let station = await this.$http.get(this.$baseURL.stationNoChildList({groupId: id}));
                console.log(station)
                this.select = [];
                let array = [];
                if(station.length > 0){
                    if(this.all){
                        array = [{id: 0, name: '不限'}];
                        this.selectId = 0;
                    }
                    console.log(this.all)
                    station.forEach((item, index) =>{
                        if(!this.all && index === 0){
                            console.log(777)
                            this.selectId = item.id;
                        }
                        array.push({
                            id: item.id,
                            name: item.name
                        })
                    });
                } else {
                    this.selectId = -1;
                    array = [{id: -1, name: '无'}];
                }
                this.select = array;
                this.changeStation();
            },
            updateSelectId(obj){
                console.log(666)
                this.$nextTick(()=>{
                    this.selectId = obj.powerStationId;
                    // this.changeGroup();
                })

            },
            changeStation(){
                this.$emit('changeStation', this.selectId);
            }
        }
    }
</script>

<style scoped>

</style>
